export default __webpack_public_path__ + "static/media/gesundheitszentrum.5782a9af.svg";